import { showElectricBicycleExtraQuestions, showLightElectricVehicleExtraQuestions } from '../components/InsuranceOffer/VehiclesQuestions';
import { buildElementId } from '../utils';
import {
  ValidateRegExp,
  ValidateSegmented,
  ValidateSelector,
  ValidateNumeric,
} from './ElementValidators';

const dataFormater = (newErrors) => ({
  add: newErrors.add.filter(Boolean),
  remove: newErrors.remove.filter(Boolean),
});

const getValue = (answer) => {
  return (answer || { value: '' }).value;
};

const buildMessage = (caption, questions, getMessage, currentQuestion, labelKey, errorKey) => {
  if (!getMessage) return '';

  return `${caption} : ${
    questions[currentQuestion]?.question || getMessage(labelKey)
  } - ${getMessage(errorKey)}`;
};

const makeVehicleTypeMuseum = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  const vehicles = ['Car', 'Van', 'Lorry'];
  const type = getValue(questions.museumVehicleType);

  newErrors = ValidateSelector(
    type,
    buildElementId(id, 'MUSEUM_VEHICLE_TYPE'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.museumVehicleType?.question || getMessage('labelText.museumVehicleType')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  return (
    vehicles.indexOf(type) > -1 ? makeVehicleTypeAuthorize : makeVehiclesOther
  )(newErrors, id, questions, validateAll, questionID, type === 'Car', caption , getMessage);
};

const removeMiledge = (id, newErrors) => {
  newErrors.remove = [
    ...newErrors.remove,
    buildElementId(id, 'VEHICLE_MILEAGE'),
  ];
  return newErrors;
};

const makeVehicleTypeAuthorize = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  hasCarInsurance,
  caption,
  getMessage
) => {
  // Registration number
  let regnoMessage =
    questions.regno?.errorLabel ||
    (getMessage
      ? `${caption} : ${
          questions.regno?.question ||
          getMessage('labelText.RegistrationNumber')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '');    
  newErrors = ValidateRegExp({
    value: getValue(questions.regno),
    id: buildElementId(id, 'REGNO'),
    newErrors,
    validateAll,
    length: 3,
    questionID,
    regExp:
      '((^[0-9a-zA-Z\\u00C0-\\u017F´`]+([ |-][0-9a-zA-Z\\u00C0-\\u017F´`]+)*$)|(^$))',
    errorLabel: regnoMessage,
  });

  // Vehicle value
  newErrors = ValidateNumeric(
    getValue(questions.vehicleValue),
    buildElementId(id, 'VEHICLE_VALUE'),
    newErrors,
    validateAll,
    1,
    999999,
    questionID,
    '^[1-9]\\d*(?:\\.\\d{1,2})?$',
    getMessage
      ? `${caption} : ${
          questions.vehicleValue?.question ||
          getMessage('labelText.vehicleValue')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  // Damage coverage included
  newErrors = ValidateSegmented(
    getValue(questions.damageCoverage),
    buildElementId(id, 'DAMAGE_COVERAGE'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.damageCoverage?.question ||
          getMessage('labelText.DamageCoverage')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  // VVH Consent
  newErrors = ValidateSegmented(
    getValue(questions.vvhConsent),
    buildElementId(id, 'VVH_CONSENT'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.vvhConsent?.question ||
          getMessage('labelText.vvhConsent')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  // Vehicle Mileage
  if (hasCarInsurance) {
    newErrors = ValidateSelector(
      getValue(questions.vehicleMileage),
      buildElementId(id, 'VEHICLE_MILEAGE'),
      newErrors,
      validateAll,
      questionID,
      getMessage
        ? `${caption} : ${
            questions.vehicleMileage?.question || getMessage('labelText.vehicleMileage')
          } - ${getMessage('error.fill.in.missing.information')}`
        : ''
    );
  } else {
    newErrors = removeMiledge(id, newErrors);
  }

  return dataFormater(newErrors);
};

const makeVehiclesOther = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  isOptional,
  caption,
  getMessage
) => {
  newErrors.remove = [
    ...newErrors.remove,
    buildElementId(id, 'VEHICLE_VALUE'),
    buildElementId(id, 'VEHICLE_MILEAGE'),
  ];

  let regnoMessage =
    questions.regno?.errorLabel ||
    (getMessage
      ? `${caption} : ${
          questions.regno?.question ||
          getMessage('labelText.RegistrationNumber')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '');

  // Registration number
  newErrors = ValidateRegExp({
    value: getValue(questions.regno),
    id: buildElementId(id, 'REGNO'),
    newErrors,
    validateAll,
    length: 3,
    questionID,
    regExp:
      '((^[0-9a-zA-Z\\u00C0-\\u017F´`]+([ |-][0-9a-zA-Z\\u00C0-\\u017F´`]+)*$)|(^$))',
    maxLimit: 20,
    isOptional,
    errorLabel: regnoMessage
  });

  if (getValue(questions.vehicleType) === 'Other vehicle') {
    let muuRegnoMessage =
    questions.muuajoneuvoregno?.errorLabel ||
    (getMessage
      ? `${caption} : ${
          questions.muuajoneuvoregno?.question ||
          getMessage('labelText.MuuAjoneuvoRegistrationNumber')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '');
    // Other Vehicle Registration number
    newErrors = ValidateRegExp({
      value: getValue(questions.muuajoneuvoregno),
      id: buildElementId(id, 'MUUAJONEUVOREGNO'),
      newErrors,
      validateAll,
      length: isOptional ? 0 : 3,
      questionID,
      regExp:
        '((^[0-9a-zA-Z\\u00C0-\\u017F´`]+([ |-][0-9a-zA-Z\\u00C0-\\u017F´`]+)*$)|(^$))',
      maxLimit: 20,
      isOptional,
      errorLabel: muuRegnoMessage
    });
  }

  // TractorInPrivateUse
  if (getValue(questions.vehicleType) === 'Tractor') {
    newErrors = ValidateSegmented(
      getValue(questions.tractorInPrivateUse),
      buildElementId(id, 'TRACTOR_IN_PRIVATE_USE'),
      newErrors,
      validateAll,
      questionID,
      buildMessage(caption, questions, getMessage, 'tractorInPrivateUse', 'labelText.tractorInPrivateUse', 'error.fill.in.missing.information')
    );
  }

  // Damage coverage included
  newErrors = ValidateSegmented(
    getValue(questions.damageCoverage),
    buildElementId(id, 'DAMAGE_COVERAGE'),
    newErrors,
    validateAll,
    questionID,
    buildMessage(caption, questions, getMessage, 'damageCoverage', 'labelText.DamageCoverage', 'error.fill.in.missing.information')
  );

  // VVH Consent
  newErrors = ValidateSegmented(
    getValue(questions.vvhConsent),
    buildElementId(id, 'VVH_CONSENT'),
    newErrors,
    validateAll,
    questionID,
    buildMessage(caption, questions, getMessage, 'dvvhConsent', 'labelText.vvhConsent', 'error.fill.in.missing.information')
  );

  return dataFormater(newErrors);
};

const makeVehiclesElectricPersonalTransportationDevice = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  isOptional,
  caption,
  getMessage
) => {

    // electricPersonalTransportationDeviceVehicleType
    newErrors = ValidateSelector(
      getValue(questions.electricPersonalTransportationDeviceVehicleType),
      buildElementId(id, 'ELECTRIC_PERSONAL_TRANSPORTATION_DEVICE_VEHICLE_TYPE'),
      newErrors,
      validateAll,
      questionID,
      buildMessage(caption, questions, getMessage, 'electricPersonalTransportationDeviceVehicleType', 'labelText.electricPersonalTransportationDeviceVehicleType', 'error.fill.in.missing.information')
    );
  
  if (getValue(questions.electricPersonalTransportationDeviceVehicleType) === "Electric bicycle") {
    newErrors.remove = [
      ...newErrors.remove,
      buildElementId(id, 'TOP_SPEED_OVER_25_KPH'),
      buildElementId(id, 'ELECTRIC_PERSONAL_TRANSPORTATION_DEVICE_AGE_UNDER_24')
    ];
    // noElectricMotorAssistanceOver25Kph
    newErrors = ValidateSegmented(
      getValue(questions.noElectricMotorAssistanceOver25Kph),
      buildElementId(id, 'NO_ELECTRIC_MOTOR_ASSISTANCE_OVER_25_KPH'),
      newErrors,
      validateAll,
      questionID,
      buildMessage(caption, questions, getMessage, 'noElectricMotorAssistanceOver25Kph', 'labelText.noElectricMotorAssistanceOver25Kph', 'error.fill.in.missing.information')
    );

    // motorPowerOver250W
    newErrors = ValidateSegmented(
      getValue(questions.motorPowerOver250W),
      buildElementId(id, 'MOTOR_POWER_OVER_250_W'),
      newErrors,
      validateAll,
      questionID,
      buildMessage(caption, questions, getMessage, 'motorPowerOver250W', 'labelText.motorPowerOver250W', 'error.fill.in.missing.information')
    );
  }
  if (getValue(questions.electricPersonalTransportationDeviceVehicleType) === "Light electric vehicle") {
    newErrors.remove = [
      ...newErrors.remove,
      buildElementId(id, 'NO_ELECTRIC_MOTOR_ASSISTANCE_OVER_25_KPH'),
      buildElementId(id, 'MOTOR_POWER_OVER_250_W'),
    ];

    // noElectricMotorAssistanceOver25Kph
    newErrors = ValidateSegmented(
      getValue(questions.topSpeedOver25Kph),
      buildElementId(id, 'TOP_SPEED_OVER_25_KPH'),
      newErrors,
      validateAll,
      questionID,
      buildMessage(caption, questions, getMessage, 'topSpeedOver25Kph', 'labelText.topSpeedOver25Kph', 'error.fill.in.missing.information')
    );
  }
  if (questions.electricPersonalTransportationDeviceVehicleType && getValue(questions.electricPersonalTransportationDeviceVehicleType) !== "choose") { 
    // weighMoreThan25Kg
    newErrors = ValidateSegmented(
      getValue(questions.weighMoreThan25Kg),
      buildElementId(id, 'WEIGHT MORE THAN 25KG'),
      newErrors,
      validateAll,
      questionID,
      buildMessage(caption, questions, getMessage, 'weighMoreThan25Kg', 'labelText.weighMoreThan25Kg', 'error.fill.in.missing.information')
    );
  }

  if (showExtraQuestions(questions)) { 
    // electricPersonalTransportationDeviceMake
    newErrors = ValidateRegExp({
      value: getValue(questions.electricPersonalTransportationDeviceMake),
      id: buildElementId(id, 'ELECTRIC_PERSONAL_TRANSPORTATION_DEVICE_MAKE'),
      newErrors,
      validateAll,
      length: 1,
      questionID,
      regExp:
        '^([0-9a-zA-Z\u00C0-\u017F]+([ |-][0-9a-zA-Z\u00C0-\u017F]+)*|)$',
      maxLimit: 100,
      isOptional,
      errorLabel: buildMessage(caption, questions, getMessage, 'electricPersonalTransportationDeviceMake', 'labelText.electricPersonalTransportationDeviceMake', 'error.fill.in.missing.information')
    });
    
    // electricPersonalTransportationDeviceModel
    newErrors = ValidateRegExp({
      value: getValue(questions.electricPersonalTransportationDeviceModel),
      id: buildElementId(id, 'ELECTRIC_PERSONAL_TRANSPORTATION_DEVICE_MODEL'),
      newErrors,
      validateAll,
      length: 1,
      questionID,
      regExp:
      '^([0-9a-zA-Z\u00C0-\u017F]+([ |-][0-9a-zA-Z\u00C0-\u017F]+)*|)$',
      maxLimit: 100,
      isOptional,
      errorLabel: buildMessage(caption, questions, getMessage, 'electricPersonalTransportationDeviceModel', 'labelText.electricPersonalTransportationDeviceModel', 'error.fill.in.missing.information')
    });

    //electricPersonalTransportationDeviceFirstYearOfService
    newErrors = ValidateNumeric(
      getValue(questions.electricPersonalTransportationDeviceFirstYearOfService),
      buildElementId(id, 'ELECTRIC_PERSONAL_TRANSPORTATION_DEVICE_FIRST_YEAR_OF_SERVICE'),
      newErrors,
      validateAll,
      1900,
      9999,
      questionID,
      '^[1-9]\\d*(?:\\.\\d{1,2})?$',
      buildMessage(caption, questions, getMessage, 'electricPersonalTransportationDeviceFirstYearOfService', 'labelText.electricPersonalTransportationDeviceFirstYearOfService', 'error.fill.in.missing.information')
    )
    // electricPersonalTransportationDeviceSerialNumber
    newErrors = ValidateRegExp({
      value: getValue(questions.electricPersonalTransportationDeviceSerialNumber),
      id: buildElementId(id, 'ELECTRIC_PERSONAL_TRANSPORTATION_DEVICE_SERIAL_NUMBER'),
      newErrors,
      validateAll,
      length: 1,
      questionID,
      regExp:
      '(^[0-9a-zA-Z\\u00C0-\\u017F´`]+$|^$)',
      maxLimit: 100,
      isOptional,
      errorLabel: buildMessage(caption, questions, getMessage, 'electricPersonalTransportationDeviceSerialNumber', 'labelText.electricPersonalTransportationDeviceSerialNumber', 'error.fill.in.missing.information')
    });

    newErrors = ValidateNumeric(
      getValue(questions.electricPersonalTransportationDevicEnginePower),
      buildElementId(id, 'ELECTRIC_PERSONAL_TRANSPORTATION_DEVICE_ENGINE_POWER'),
      newErrors,
      validateAll,
      1,
      9999,
      questionID,
      '^[1-9]\\d*(?:\\.\\d{1,2})?$',
      buildMessage(caption, questions, getMessage, 'electricPersonalTransportationDevicEnginePower', 'labelText.electricPersonalTransportationDevicEnginePower', 'error.fill.in.missing.information')
    )

    // electricPersonalTransportationDeviceMaximumDesignSpeed
    newErrors = ValidateNumeric(
      getValue(questions.electricPersonalTransportationDeviceMaximumDesignSpeed),
      buildElementId(id, 'ELECTRIC_PERSONAL_TRANSPORTATION_DEVICE_MAXIMUM_DESIGN_SPEED'),
      newErrors,
      validateAll,
      1,
      999,
      questionID,
      '^[1-9]\\d*(?:\\.\\d{1,2})?$',
      buildMessage(caption, questions, getMessage, 'electricPersonalTransportationDeviceMaximumDesignSpeed', 'labelText.electricPersonalTransportationDeviceMaximumDesignSpeed', 'error.fill.in.missing.information')
    )

    // electricPersonalTransportationDeviceTotalWeight
    newErrors = ValidateNumeric(
      getValue(questions.electricPersonalTransportationDeviceTotalWeight),
      buildElementId(id, 'ELECTRIC_PERSONAL_TRANSPORTATION_DEVICE_TOTAL_WEIGHT'),
      newErrors,
      validateAll,
      1,
      999,
      questionID,
      '^[1-9]\\d*(?:\\.\\d{1,2})?$',
      buildMessage(caption, questions, getMessage, 'electricPersonalTransportationDeviceTotalWeight', 'labelText.electricPersonalTransportationDeviceTotalWeight', 'error.fill.in.missing.information')
    )

    // electricPersonalTransportationDeviceCollisionCrashCoverage
    newErrors = ValidateSegmented(
      getValue(questions.electricPersonalTransportationDeviceCollisionCrashCoverage),
      buildElementId(id, 'ELECTRIC_PERSONAL_TRANSPORTATION_DEVICE_COLLISION_CRASH_COVERAGE'),
      newErrors,
      validateAll,
      questionID,
      buildMessage(caption, questions, getMessage, 'electricPersonalTransportationDeviceCollisionCrashCoverage', 'labelText.electricPersonalTransportationDeviceCollisionCrashCoverage', 'error.fill.in.missing.information')
    );
  }
  if (getValue(questions.electricPersonalTransportationDeviceVehicleType) === "Electric bicycle" && showExtraQuestions(questions)) { 
    // electricPersonalTransportationDeviceValue
    newErrors = ValidateNumeric(
      getValue(questions.electricPersonalTransportationDeviceValue),
      buildElementId(id, 'ELECTRIC_PERSONAL_TRANSPORTATION_DEVICE_VALUE'),
      newErrors,
      validateAll,
      1,
      999999,
      questionID,
      '^[1-9]\\d*(?:\\.\\d{1,2})?$',
      buildMessage(caption, questions, getMessage, 'electricPersonalTransportationDeviceValue', 'labelText.electricPersonalTransportationDeviceValue', 'error.fill.in.missing.information')
    )
  }

  if (getValue(questions.electricPersonalTransportationDeviceVehicleType) === "Light electric vehicle" && showExtraQuestions(questions)) { 
    buildElementId(id, 'ELECTRIC_PERSONAL_TRANSPORTATION_DEVICE_VALUE')
     // electricPersonalTransportationDeviceAgeUnder24
     newErrors = ValidateSegmented(
      getValue(questions.electricPersonalTransportationDeviceAgeUnder24),
      buildElementId(id, 'ELECTRIC_PERSONAL_TRANSPORTATION_DEVICE_AGE_UNDER_24'),
      newErrors,
      validateAll,
      questionID,
      buildMessage(caption, questions, getMessage, 'electricPersonalTransportationDeviceAgeUnder24', 'labelText.electricPersonalTransportationDeviceAgeUnder24', 'error.fill.in.missing.information')
    );
  }

  return dataFormater(newErrors);
};

const validateVehiclesQuestions = (
  id,
  questions,
  validateAll,
  questionID,
  errors,
  caption,
  getMessage
) => {
  let newErrors = { add: [], remove: [] };
  const vehicleType = questions.vehicleType || { value: '' };

  // Mandatory, validate always type
  newErrors = ValidateSelector(
    vehicleType.value,
    buildElementId(id, 'VEHICLE_TYPE'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.vehicleType?.question || getMessage('labelText.vehicleType')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  if (validateAll === true && vehicleType.value === 'choose') {
    newErrors.remove = [
      ...newErrors.remove,
      ...errors
        .filter(
          (record) =>
            record.id.indexOf(id) !== -1 && record.id !== id + '_VEHICLE_TYPE'
        )
        .map((record) => record.id),
    ];
  }

  switch (vehicleType.value) {
    case 'Museum vehicle':
      return makeVehicleTypeMuseum(
        newErrors,
        id,
        questions,
        validateAll,
        questionID,
        caption,
        getMessage
      );
    case 'Car':
    case 'Van':
    case 'Lorry':
      return makeVehicleTypeAuthorize(
        newErrors,
        id,
        questions,
        validateAll,
        questionID,
        vehicleType.value === 'Car',
        caption,
        getMessage
      );
    case 'Electric Personal Transportation Device':
      return makeVehiclesElectricPersonalTransportationDevice(
        newErrors,
        id,
        questions,
        validateAll,
        questionID,
        false,
        caption,
        getMessage
      );
    case 'Motorcycle':
    case 'Campervan':
    case 'Moped or light quadricycle':
    case 'Snowmobile':
    case 'Trailer':
    case 'Caravan':
    case 'Tractor':
    case 'All-terrain vehicle':
    case 'Other vehicle':
      return makeVehiclesOther(
        newErrors,
        id,
        questions,
        validateAll,
        questionID,
        vehicleType.value === 'Other vehicle',
        caption,
        getMessage
      );
    default:
      return dataFormater(newErrors);
  }
};

export default validateVehiclesQuestions;

const showExtraQuestions = (questions) => {
  if (getValue(questions.electricPersonalTransportationDeviceVehicleType) === 'Electric bicycle') {
    return showElectricBicycleExtraQuestions(
      getValue(questions.noElectricMotorAssistanceOver25Kph),
      getValue(questions.motorPowerOver250W),
      getValue(questions.weighMoreThan25Kg)
    )
  } else if (getValue(questions.electricPersonalTransportationDeviceVehicleType) === 'Light electric vehicle') {
    return showLightElectricVehicleExtraQuestions(
      getValue(questions.topSpeedOver25Kph),
      getValue(questions.weighMoreThan25Kg)
    )
  }
  else {
    return false
  }
}